import { render, staticRenderFns } from "./PreviewComponent.vue?vue&type=template&id=0c6edaac&lang=pug"
import script from "./PreviewComponent.vue?vue&type=script&lang=ts"
export * from "./PreviewComponent.vue?vue&type=script&lang=ts"
import style0 from "./PreviewComponent.vue?vue&type=style&index=0&id=0c6edaac&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6edaac')) {
      api.createRecord('0c6edaac', component.options)
    } else {
      api.reload('0c6edaac', component.options)
    }
    module.hot.accept("./PreviewComponent.vue?vue&type=template&id=0c6edaac&lang=pug", function () {
      api.rerender('0c6edaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/PreviewComponent.vue"
export default component.exports